<template>
  <div class="filter-group">
    <label class="filter-label">{{ label }}:</label>
    <div class="filter-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterGroup',
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.filter-group {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
}

.filter-label {
  color: rgba(0, 0, 0, 0.85);
  min-width: 88px;
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1.5;
}

.filter-content {
  flex: 1;
  display: flex;
  align-items: center;
}
</style>

